import { Component, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, BaseChartDirective } from 'ng2-charts';
import { AdminService } from '../../services/admin/AdminService';
import { Globals } from '../../globals';
declare var $: any;
declare var jquery: any;
import { GridOptions } from "ag-grid/main";
//import * as pluginAnnotations from 'chartjs-plugin-annotation';


@Component({
  selector: 'app-admin-dasboard',
  templateUrl: './admin-dasboard.component.html',
  styleUrls: ['./admin-dasboard.component.scss']
})
export class AdminDasboardComponent implements OnInit {

    @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>
    public years: number[] = [];

    public selfData: ChartDataSets[] = [];
    public assessment360Data: ChartDataSets[] = [];
    public lineChartLabels: string[] = [];
    public lineChartLabels360: string[] = [];
    public lineChartOptions: (ChartOptions & any ) = {
        tooltips: {
            enabled: true
        },
        plugins: {
            datalabels: {
                display: false
            }
        },
        responsive: true,
        scales: {
            // We use this empty structure as a placeholder for dynamic theming.
            xAxes: [{}],
            yAxes: [
                {
                    id: 'y-axis-0',
                    position: 'left',
                }
            ]
        }
    };
    public lineChartColors: Color[] = [
        { // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // light green
            backgroundColor: 'rgb(116,220,172, 0.2)',
            borderColor: 'rgb(116,220,172, 1)',
            pointBackgroundColor: 'rgb(116,220,172, 1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgb(116,220,172, 1)'
        },
        { // red
            backgroundColor: 'rgba(255,0,0,0.3)',
            borderColor: 'red',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    ];
    public lineChartLegend = true;
    public lineChartType: ChartType = 'line';
    //public lineChartPlugins = [pluginAnnotations];

    loading: boolean = true;
    selfAssessments: any = {};
    assessments360: any = {};

    //AG-GRID
    selfGridData: string[] = [];
    GridData360: string[] = [];
    gridHeaders: any[];
    gridOptions: GridOptions;
    gridApi:any = {};
    gridColumnApi;
    overlayNoRowsTemplate;
    height: number;
    count: number;  
    currentYear: number = new Date().getFullYear();
    defaultInterval: number = 3;
    intervals = [
        {
            "label": "Daily",
            "value": 1
        },
        {
            "label": "Weekly",
            "value": 2
        },
        {
            "label": "Monthly",
            "value": 3
        },
    ];
    chartReady: boolean = false;


    constructor(
        private _AdminService: AdminService,
        private _Globals: Globals
    ) {

        this.generateYears();
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
    }

    generateYears() {
        let i = 0;
        let year = 2020;
        while (i <= 10) {
            this.years.push(year);
            i++;
            year++;
        }
        console.log(this.years);
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.gridHeaders = this.createHeaders();

        this.filterByYear(true, 1, new Date().getFullYear(), 3); 
        this.getStatisticsTodaysData();
    }

    filterByYear(firstLoad, assessmentId, year, interval) {
        this.getStatisticsChartData(firstLoad, year, assessmentId, interval);        
    }

    changeYear(assessmentId: number) {
        let year;
        let interval;
        if (assessmentId === 1) {
            year = $('#selfYear').val();
            interval = $('#selfInterval').val();
        } else {
            year = $('#year360').val();
            interval = $('#interval360').val();
        }
        
        this.filterByYear(false, assessmentId, year, parseInt(interval));    
    }

    changeInterval(assessmentId: number) {
        let year;
        let interval;
        if (assessmentId === 1) {
            year = $('#selfYear').val();
            interval = $('#selfInterval').val();
        } else {
            year = $('#year360').val();
            interval = $('#interval360').val();
        }

        this.filterByYear(false, assessmentId, year, parseInt(interval));
    }

    getStatisticsChartData(firstload: boolean, year: number, assessmentId: number, interval: number) {
        this._AdminService.PostGetStatisticsChartsData(year, assessmentId, interval).subscribe((data: any) => {
            console.log('response_getAdminDashboardData', data);
            if (this._Globals.validationToken(data.result.Result)) {
                
                const _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                switch (assessmentId) {
                    case 1:
                        if (firstload) this.lineChartLabels = _data.Assigned.DataLabels;
                        this.selfData = [
                            { data: _data.Assigned.Data, label: _data.Assigned.Label },
                            { data: _data.Completed.Data, label: _data.Completed.Label },
                            { data: _data.Purchased.Data, label: _data.Purchased.Label }
                        ]
                        setTimeout(() => {
                            if (this.charts.first && this.charts.first.chart && this.charts.first.chart.config) {
                                this.charts.first.chart.config.data.labels = _data.Assigned.DataLabels;
                                //this.charts[0].chart.config.data.datasets = ;
                                this.charts.first.chart.update();                               
                            }                            
                        });

                        this.selfGridData = _data.TabularStatistics;

                        if (firstload) this.getStatisticsChartData(true, year, 34, interval);
                        break;

                    case 34:
                        if (firstload) this.lineChartLabels360 = _data.Assigned.DataLabels;
                        this.assessment360Data = [
                            { data: _data.Assigned.Data, label: _data.Assigned.Label },
                            { data: _data.Completed.Data, label: _data.Completed.Label },
                            { data: _data.Purchased.Data, label: _data.Purchased.Label }
                        ];
                        setTimeout(() => {
                            if (this.charts.last && this.charts.last.chart && this.charts.last.chart.config) {
                                this.charts.last.chart.config.data.labels = _data.Assigned.DataLabels;
                                //this.charts[1].chart.config.data.datasets = 
                                this.charts.last.chart.update();
                            }
                            this.chartReady = true;
                        });

                        this.GridData360 = _data.TabularStatistics;

                        this.loading = false;
                        break
                }
                
            }
        })
    }

    getStatisticsTodaysData() {
        this._AdminService.PostGetStatisticsTodaysData().subscribe((data: any) => {
            console.log('response_PostGetStatisticsTodaysData', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                this.selfAssessments.assigned = _data.SelfAssessmentsAssigned; 
                this.selfAssessments.completed = _data.SelfAssessmentsCompleted;
                this.selfAssessments.purchased = _data.SelfAssessmentsPurchased;

                this.assessments360.assigned = _data.Assessments360Assigned;
                this.assessments360.completed = _data.Assessments360Completed; 
                this.assessments360.purchased = _data.Assessments360Purchased; 

            }
        });
    }

    //AG-GRID METHODS
    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(assessmentType: number, params) {
        if (assessmentType == 1) {
            this.gridApi.self_grid = params.api;
            this.sizeToFit(this.gridApi.self_grid);
        } else {
            this.gridApi.grid_360 = params.api;
            this.sizeToFit(this.gridApi.grid_360);
        }
        
        
    }

    createHeaders() {
        let columnDefs = new Array();
        console.log('header');

        let monthHeader = {
            headerName: 'Interval',
            field: 'Label',
            minWidth: 100,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(monthHeader);

        let purchasedHeader = {
            headerName: 'Purchased',
            field: 'Purchased',
            minWidth: 102,
            width: 102,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(purchasedHeader);

        let assignedHeader = {
            headerName: 'Assigned',
            field: 'Assigned',
            minWidth: 95,
            width: 95,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(assignedHeader);

        let completedHeader = {
            headerName: 'Completed',
            field: 'Completed',
            minWidth: 105,
            width: 105,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(completedHeader);

        return columnDefs;
    }

    onRowClicked(e) {
        console.log(e);
    }

    exportByAssessmentType(assessmentType: number) {
        if (assessmentType == 1) {
            this.exportToCsv('SelfAssessments_Statistics_' + $('#selfYear').val() + '.csv', this.gridApi.self_grid);
        } else {
            this.exportToCsv('360Assessments_Statistics_' + $('#selfYear').val() + '.csv', this.gridApi.grid_360);
        }
    }

    exportToCsv(file_name: string, gridApi) {
        var params = this.getSelfParams(file_name);
        if (params.suppressQuotes || params.columnSeparator) {
            console.log(
                'NOTE: you are downloading a file with non-standard quotes or separators - it may not render correctly in Excel.'
            );
        }
        gridApi.exportDataAsCsv(params);
    }

    getSelfParams(file_name) {
        return {
            suppressQuotes: false,
            columnSeparator: ',',
            customHeader: false,
            customFooter: false,
            fileName: file_name
        };
    }

    setView(assessmentId: number, e: any) {
        console.log(e);

        if (e.target.classList[2] != 'active') {
            switch (assessmentId) {
                case 1:
                    $('.selfActions i').removeClass('active');
                    this.toggleVisibility('selfChartWrap');
                    this.toggleVisibility('selfGridWrap');
                    break;

                case 34:
                    $('.actions360 i').removeClass('active');
                    this.toggleVisibility('chartWrap360');
                    this.toggleVisibility('gridWrap360');

                    break;
            }

            e.target.classList.add("active");
        }
    }

    toggleVisibility(element_id) {
        var x = document.getElementById(element_id);
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            x.style.display = "none";
        }
    }



}
